import React, { useState, useEffect } from 'react';
import { FiPlus, FiEdit2, FiTrash2, FiChevronLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './District.css';
// const url = import.meta.env.VITE_BACKEND_URL;
const url = process.env.REACT_APP_BACKEND_URL;

const District = () => {
  const [districts, setDistricts] = useState([]);
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [filteredRegions, setFilteredRegions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ name: '', country: '', region: '' });
  const [isEdit, setIsEdit] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [districtRes, countryRes, regionRes] = await Promise.all([
        axios.get(`${url}/api/district`),
        axios.get(`${url}/api/country`),
        axios.get(`${url}/api/regions`),
      ]);
      setDistricts(districtRes.data.data || []);
      setCountries(countryRes.data.data || []);
      setRegions(regionRes.data.data || []);
      setIsLoading(false);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to fetch data');
      setIsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));

    // Filter regions when country changes
    if (name === 'country') {
      const filtered = regions.filter(r => r.country?._id === value);
      setFilteredRegions(filtered);
      setFormData(prev => ({ ...prev, region: '' })); // reset region selection
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEdit) {
        await axios.put(`${url}/api/district/${currentId}`, formData);
      } else {
        await axios.post(`${url}/api/district`, formData);
      }
      fetchData();
      resetForm();
    } catch (err) {
      setError(err.response?.data?.message || 'Operation failed');
    }
  };

  const handleEdit = (district) => {
    setFormData({
      name: district.name,
      country: district.country?._id || '',
      region: district.region?._id || ''
    });
    const filtered = regions.filter(r => r.country?._id === district.country?._id);
    setFilteredRegions(filtered);
    setIsEdit(true);
    setCurrentId(district._id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this district?')) {
      try {
        await axios.delete(`${url}/api/district/${id}`);
        fetchData();
      } catch (err) {
        setError(err.response?.data?.message || 'Delete failed');
      }
    }
  };

  const resetForm = () => {
    setFormData({ name: '', country: '', region: '' });
    setFilteredRegions([]);
    setIsEdit(false);
    setCurrentId(null);
    setShowForm(false);
  };

  if (isLoading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="district-container">
      <div className="header">
        <button onClick={() => navigate(-1)} className="back-button">
          <FiChevronLeft /> Back
        </button>
        <h2>{showForm ? (isEdit ? 'Edit District' : 'Add New District') : 'Districts'}</h2>
        {!showForm && (
          <button onClick={() => setShowForm(true)} className="add-button">
            <FiPlus /> Add District
          </button>
        )}
      </div>

      {showForm ? (
        <form onSubmit={handleSubmit} className="district-form">
          <div className="form-group">
            <label>District Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Country</label>
            <select
              name="country"
              value={formData.country}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Country</option>
              {countries.map(country => (
                <option key={country._id} value={country._id}>
                  {country.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Region</label>
            <select
              name="region"
              value={formData.region}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Region</option>
              {filteredRegions.map(region => (
                <option key={region._id} value={region._id}>
                  {region.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-actions">
            <button type="submit" className="submit-button">
              {isEdit ? 'Update' : 'Save'}
            </button>
            <button type="button" onClick={resetForm} className="cancel-button">
              Cancel
            </button>
          </div>
        </form>
      ) : (
        <div className="district-list">
          {districts.length === 0 ? (
            <div className="no-data">No districts found</div>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>District Name</th>
                  <th>Region</th>
                  <th>Country</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {districts.map(district => (
                  <tr key={district._id}>
                    <td>{district.name}</td>
                    <td>{district.region?.name}</td>
                    <td>{district.country?.name}</td>
                    <td className="actions">
                      <button onClick={() => handleEdit(district)} className="edit">
                        <FiEdit2 />
                      </button>
                      {/* <button onClick={() => handleDelete(district._id)} className="delete">
                        <FiTrash2 />
                      </button> */}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
};

export default District;
